import { FeatureConfiguration } from "features";
import { Takeaway } from "./components/Takeaway";

export default function (config: FeatureConfiguration) {
    config.addRoutes(config.routes.locationRoutes, [<Takeaway key="takeaway-settings" />]);
}
